import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import {
  AdCopyStatus,
  AdGroupStatus,
  ApiTokenStatus,
  InvoiceStatus,
  Status,
  UserStatus,
} from '../__generated__/graphql'
import { useAppTranslations } from '../utils/hooks/useAppTranslations'
import { resolveStatusStyledColor, StatusStyledStatus } from '../styles/theme/status'

const getStatusStyledLabelKey = (status: StatusStyledStatus): string => {
  if (Object.values(InvoiceStatus).includes(status as InvoiceStatus)) return `billing.${status}`
  return `commons.${status.toLowerCase()}`
}

export const StatusStyled: React.FC<{
  status: Status | AdGroupStatus | AdCopyStatus | UserStatus | ApiTokenStatus | InvoiceStatus | 'Paused' | 'Waiting'
}> = ({ status }) => {
  const t = useAppTranslations()

  const statusStyle = useMemo(
    () => ({
      color: resolveStatusStyledColor(status),
      fontWeight: 'bold',
    }),
    [status]
  )

  return (
    <Box sx={statusStyle}>
      <span>{t(getStatusStyledLabelKey(status))}</span>
    </Box>
  )
}
